/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 202610.20.01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CheckCustomer } from '../model/models';
import { ClaimRewardDto } from '../model/models';
import { ClaimedReward } from '../model/models';
import { CreateClick } from '../model/models';
import { Customer } from '../model/models';
import { CustomerBoostsResponseDto } from '../model/models';
import { CustomerData } from '../model/models';
import { GooglePass } from '../model/models';
import { MultiPassLink } from '../model/models';
import { PaginatedCustomerCouponCodes } from '../model/models';
import { PaginatedTransactions } from '../model/models';
import { ProfileFormErrorDto } from '../model/models';
import { ProfileFormStateDto } from '../model/models';
import { Program } from '../model/models';
import { ProgramIntegration } from '../model/models';
import { RegisterCustomer } from '../model/models';
import { RegisterResponseDto } from '../model/models';
import { Reward } from '../model/models';
import { UpdateCustomerPreferences } from '../model/models';
import { UpdateCustomerProfile } from '../model/models';
import { UpdateProfileFormDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    ProgramServiceInterface,
    ProfileFormControllerGetProfileFormV1RequestParams,
    ProfileFormControllerUpdateProfileFormV1RequestParams,
    ProgramControllerCheckCustomerExistsV1RequestParams,
    ProgramControllerClaimCouponCodeV1RequestParams,
    ProgramControllerClaimCustomerRewardV1RequestParams,
    ProgramControllerGetAnonymousCouponApplePassV1RequestParams,
    ProgramControllerGetAnonymousCouponGooglePassV1RequestParams,
    ProgramControllerGetApplePassV1RequestParams,
    ProgramControllerGetBoostsV1RequestParams,
    ProgramControllerGetCouponUniqueCodeApplePassV1RequestParams,
    ProgramControllerGetCouponUniqueCodeGooglePassV1RequestParams,
    ProgramControllerGetCustomerCouponCodesV1RequestParams,
    ProgramControllerGetCustomerCouponsV1RequestParams,
    ProgramControllerGetCustomerDataV1RequestParams,
    ProgramControllerGetCustomerMultiPassLinkV1RequestParams,
    ProgramControllerGetCustomerTransactionsV1RequestParams,
    ProgramControllerGetGooglePassV1RequestParams,
    ProgramControllerGetProgramIntegrationsV1RequestParams,
    ProgramControllerGetProgramV1RequestParams,
    ProgramControllerRefundCustomerRewardV1RequestParams,
    ProgramControllerRegisterCustomerV1RequestParams,
    ProgramControllerSendPassToCustomerV1RequestParams,
    ProgramControllerSendValidationEmailV1RequestParams,
    ProgramControllerStoreCustomerClickV1RequestParams,
    ProgramControllerUpdateCustomerPreferencesV1RequestParams,
    ProgramControllerUpdateCustomerProfileV1RequestParams,
    ProgramControllerValidateCustomerV1RequestParams
} from './program.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ProgramService implements ProgramServiceInterface {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public profileFormControllerGetProfileFormV1(requestParameters: ProfileFormControllerGetProfileFormV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ProfileFormStateDto>;
    public profileFormControllerGetProfileFormV1(requestParameters: ProfileFormControllerGetProfileFormV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ProfileFormStateDto>>;
    public profileFormControllerGetProfileFormV1(requestParameters: ProfileFormControllerGetProfileFormV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ProfileFormStateDto>>;
    public profileFormControllerGetProfileFormV1(requestParameters: ProfileFormControllerGetProfileFormV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling profileFormControllerGetProfileFormV1.');
        }
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<ProfileFormStateDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/profile-form`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public profileFormControllerUpdateProfileFormV1(requestParameters: ProfileFormControllerUpdateProfileFormV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ProfileFormStateDto>;
    public profileFormControllerUpdateProfileFormV1(requestParameters: ProfileFormControllerUpdateProfileFormV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ProfileFormStateDto>>;
    public profileFormControllerUpdateProfileFormV1(requestParameters: ProfileFormControllerUpdateProfileFormV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ProfileFormStateDto>>;
    public profileFormControllerUpdateProfileFormV1(requestParameters: ProfileFormControllerUpdateProfileFormV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const updateProfileFormDto = requestParameters.updateProfileFormDto;
        if (updateProfileFormDto === null || updateProfileFormDto === undefined) {
            throw new Error('Required parameter updateProfileFormDto was null or undefined when calling profileFormControllerUpdateProfileFormV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling profileFormControllerUpdateProfileFormV1.');
        }
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<ProfileFormStateDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/profile-form`,
            updateProfileFormDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerCheckCustomerExistsV1(requestParameters: ProgramControllerCheckCustomerExistsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerCheckCustomerExistsV1(requestParameters: ProgramControllerCheckCustomerExistsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerCheckCustomerExistsV1(requestParameters: ProgramControllerCheckCustomerExistsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerCheckCustomerExistsV1(requestParameters: ProgramControllerCheckCustomerExistsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const checkCustomer = requestParameters.checkCustomer;
        if (checkCustomer === null || checkCustomer === undefined) {
            throw new Error('Required parameter checkCustomer was null or undefined when calling programControllerCheckCustomerExistsV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerCheckCustomerExistsV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/check`,
            checkCustomer,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerClaimCouponCodeV1(requestParameters: ProgramControllerClaimCouponCodeV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerClaimCouponCodeV1(requestParameters: ProgramControllerClaimCouponCodeV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerClaimCouponCodeV1(requestParameters: ProgramControllerClaimCouponCodeV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerClaimCouponCodeV1(requestParameters: ProgramControllerClaimCouponCodeV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerClaimCouponCodeV1.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling programControllerClaimCouponCodeV1.');
        }
        const couponCodeValue = requestParameters.couponCodeValue;
        if (couponCodeValue === null || couponCodeValue === undefined) {
            throw new Error('Required parameter couponCodeValue was null or undefined when calling programControllerClaimCouponCodeV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/codes/${encodeURIComponent(String(couponCodeValue))}/claim`,
            null,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerClaimCustomerRewardV1(requestParameters: ProgramControllerClaimCustomerRewardV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ClaimedReward>;
    public programControllerClaimCustomerRewardV1(requestParameters: ProgramControllerClaimCustomerRewardV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ClaimedReward>>;
    public programControllerClaimCustomerRewardV1(requestParameters: ProgramControllerClaimCustomerRewardV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ClaimedReward>>;
    public programControllerClaimCustomerRewardV1(requestParameters: ProgramControllerClaimCustomerRewardV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerClaimCustomerRewardV1.');
        }
        const rewardId = requestParameters.rewardId;
        if (rewardId === null || rewardId === undefined) {
            throw new Error('Required parameter rewardId was null or undefined when calling programControllerClaimCustomerRewardV1.');
        }
        const claimRewardDto = requestParameters.claimRewardDto;
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<ClaimedReward>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/rewards/${encodeURIComponent(String(rewardId))}/claim`,
            claimRewardDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetAnonymousCouponApplePassV1(requestParameters: ProgramControllerGetAnonymousCouponApplePassV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerGetAnonymousCouponApplePassV1(requestParameters: ProgramControllerGetAnonymousCouponApplePassV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerGetAnonymousCouponApplePassV1(requestParameters: ProgramControllerGetAnonymousCouponApplePassV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerGetAnonymousCouponApplePassV1(requestParameters: ProgramControllerGetAnonymousCouponApplePassV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetAnonymousCouponApplePassV1.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling programControllerGetAnonymousCouponApplePassV1.');
        }
        const campaignSlug = requestParameters.campaignSlug;
        if (campaignSlug === null || campaignSlug === undefined) {
            throw new Error('Required parameter campaignSlug was null or undefined when calling programControllerGetAnonymousCouponApplePassV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;
        const couponCode = requestParameters.couponCode;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }
        if (campaignSlug !== undefined && campaignSlug !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>campaignSlug, 'campaign-slug');
        }
        if (couponCode !== undefined && couponCode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>couponCode, 'coupon-code');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/anonymous-coupons/${encodeURIComponent(String(couponId))}/apple/pass`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetAnonymousCouponGooglePassV1(requestParameters: ProgramControllerGetAnonymousCouponGooglePassV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerGetAnonymousCouponGooglePassV1(requestParameters: ProgramControllerGetAnonymousCouponGooglePassV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerGetAnonymousCouponGooglePassV1(requestParameters: ProgramControllerGetAnonymousCouponGooglePassV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerGetAnonymousCouponGooglePassV1(requestParameters: ProgramControllerGetAnonymousCouponGooglePassV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetAnonymousCouponGooglePassV1.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling programControllerGetAnonymousCouponGooglePassV1.');
        }
        const campaignSlug = requestParameters.campaignSlug;
        if (campaignSlug === null || campaignSlug === undefined) {
            throw new Error('Required parameter campaignSlug was null or undefined when calling programControllerGetAnonymousCouponGooglePassV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;
        const couponCode = requestParameters.couponCode;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }
        if (campaignSlug !== undefined && campaignSlug !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>campaignSlug, 'campaign-slug');
        }
        if (couponCode !== undefined && couponCode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>couponCode, 'coupon-code');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/anonymous-coupons/${encodeURIComponent(String(couponId))}/google/pass`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetApplePassV1(requestParameters: ProgramControllerGetApplePassV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerGetApplePassV1(requestParameters: ProgramControllerGetApplePassV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerGetApplePassV1(requestParameters: ProgramControllerGetApplePassV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerGetApplePassV1(requestParameters: ProgramControllerGetApplePassV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetApplePassV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/apple/pass`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetBoostsV1(requestParameters: ProgramControllerGetBoostsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerBoostsResponseDto>;
    public programControllerGetBoostsV1(requestParameters: ProgramControllerGetBoostsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerBoostsResponseDto>>;
    public programControllerGetBoostsV1(requestParameters: ProgramControllerGetBoostsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerBoostsResponseDto>>;
    public programControllerGetBoostsV1(requestParameters: ProgramControllerGetBoostsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetBoostsV1.');
        }
        const window = requestParameters.window;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (window !== undefined && window !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>window, 'window');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<CustomerBoostsResponseDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/boosts`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetCouponUniqueCodeApplePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeApplePassV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerGetCouponUniqueCodeApplePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeApplePassV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerGetCouponUniqueCodeApplePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeApplePassV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerGetCouponUniqueCodeApplePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeApplePassV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetCouponUniqueCodeApplePassV1.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling programControllerGetCouponUniqueCodeApplePassV1.');
        }
        const couponCodeValue = requestParameters.couponCodeValue;
        if (couponCodeValue === null || couponCodeValue === undefined) {
            throw new Error('Required parameter couponCodeValue was null or undefined when calling programControllerGetCouponUniqueCodeApplePassV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/codes/${encodeURIComponent(String(couponCodeValue))}/apple/pass`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetCouponUniqueCodeGooglePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeGooglePassV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerGetCouponUniqueCodeGooglePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeGooglePassV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerGetCouponUniqueCodeGooglePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeGooglePassV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerGetCouponUniqueCodeGooglePassV1(requestParameters: ProgramControllerGetCouponUniqueCodeGooglePassV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetCouponUniqueCodeGooglePassV1.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling programControllerGetCouponUniqueCodeGooglePassV1.');
        }
        const couponCodeValue = requestParameters.couponCodeValue;
        if (couponCodeValue === null || couponCodeValue === undefined) {
            throw new Error('Required parameter couponCodeValue was null or undefined when calling programControllerGetCouponUniqueCodeGooglePassV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/codes/${encodeURIComponent(String(couponCodeValue))}/google/pass`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetCustomerCouponCodesV1(requestParameters: ProgramControllerGetCustomerCouponCodesV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PaginatedCustomerCouponCodes>;
    public programControllerGetCustomerCouponCodesV1(requestParameters: ProgramControllerGetCustomerCouponCodesV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PaginatedCustomerCouponCodes>>;
    public programControllerGetCustomerCouponCodesV1(requestParameters: ProgramControllerGetCustomerCouponCodesV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PaginatedCustomerCouponCodes>>;
    public programControllerGetCustomerCouponCodesV1(requestParameters: ProgramControllerGetCustomerCouponCodesV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetCustomerCouponCodesV1.');
        }
        const limit = requestParameters.limit;
        const page = requestParameters.page;
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<PaginatedCustomerCouponCodes>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/coupon-codes`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetCustomerCouponsV1(requestParameters: ProgramControllerGetCustomerCouponsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<Reward>>;
    public programControllerGetCustomerCouponsV1(requestParameters: ProgramControllerGetCustomerCouponsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<Reward>>>;
    public programControllerGetCustomerCouponsV1(requestParameters: ProgramControllerGetCustomerCouponsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<Reward>>>;
    public programControllerGetCustomerCouponsV1(requestParameters: ProgramControllerGetCustomerCouponsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetCustomerCouponsV1.');
        }
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<Reward>>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/rewards`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetCustomerDataV1(requestParameters: ProgramControllerGetCustomerDataV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerData>;
    public programControllerGetCustomerDataV1(requestParameters: ProgramControllerGetCustomerDataV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerData>>;
    public programControllerGetCustomerDataV1(requestParameters: ProgramControllerGetCustomerDataV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerData>>;
    public programControllerGetCustomerDataV1(requestParameters: ProgramControllerGetCustomerDataV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetCustomerDataV1.');
        }
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<CustomerData>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetCustomerMultiPassLinkV1(requestParameters: ProgramControllerGetCustomerMultiPassLinkV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<MultiPassLink>>;
    public programControllerGetCustomerMultiPassLinkV1(requestParameters: ProgramControllerGetCustomerMultiPassLinkV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<MultiPassLink>>>;
    public programControllerGetCustomerMultiPassLinkV1(requestParameters: ProgramControllerGetCustomerMultiPassLinkV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<MultiPassLink>>>;
    public programControllerGetCustomerMultiPassLinkV1(requestParameters: ProgramControllerGetCustomerMultiPassLinkV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetCustomerMultiPassLinkV1.');
        }
        const redirectUrl = requestParameters.redirectUrl;
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (redirectUrl !== undefined && redirectUrl !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>redirectUrl, 'redirect_url');
        }

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<MultiPassLink>>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/multi-pass-link`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetCustomerTransactionsV1(requestParameters: ProgramControllerGetCustomerTransactionsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PaginatedTransactions>;
    public programControllerGetCustomerTransactionsV1(requestParameters: ProgramControllerGetCustomerTransactionsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PaginatedTransactions>>;
    public programControllerGetCustomerTransactionsV1(requestParameters: ProgramControllerGetCustomerTransactionsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PaginatedTransactions>>;
    public programControllerGetCustomerTransactionsV1(requestParameters: ProgramControllerGetCustomerTransactionsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetCustomerTransactionsV1.');
        }
        const limit = requestParameters.limit;
        const page = requestParameters.page;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<PaginatedTransactions>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/transactions`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetGooglePassV1(requestParameters: ProgramControllerGetGooglePassV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GooglePass>;
    public programControllerGetGooglePassV1(requestParameters: ProgramControllerGetGooglePassV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GooglePass>>;
    public programControllerGetGooglePassV1(requestParameters: ProgramControllerGetGooglePassV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GooglePass>>;
    public programControllerGetGooglePassV1(requestParameters: ProgramControllerGetGooglePassV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetGooglePassV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<GooglePass>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/google/pass`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetProgramIntegrationsV1(requestParameters: ProgramControllerGetProgramIntegrationsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ProgramIntegration>>;
    public programControllerGetProgramIntegrationsV1(requestParameters: ProgramControllerGetProgramIntegrationsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ProgramIntegration>>>;
    public programControllerGetProgramIntegrationsV1(requestParameters: ProgramControllerGetProgramIntegrationsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ProgramIntegration>>>;
    public programControllerGetProgramIntegrationsV1(requestParameters: ProgramControllerGetProgramIntegrationsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetProgramIntegrationsV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<ProgramIntegration>>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/integrations`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerGetProgramV1(requestParameters: ProgramControllerGetProgramV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Program>;
    public programControllerGetProgramV1(requestParameters: ProgramControllerGetProgramV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Program>>;
    public programControllerGetProgramV1(requestParameters: ProgramControllerGetProgramV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Program>>;
    public programControllerGetProgramV1(requestParameters: ProgramControllerGetProgramV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerGetProgramV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Program>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerRefundCustomerRewardV1(requestParameters: ProgramControllerRefundCustomerRewardV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerRefundCustomerRewardV1(requestParameters: ProgramControllerRefundCustomerRewardV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerRefundCustomerRewardV1(requestParameters: ProgramControllerRefundCustomerRewardV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerRefundCustomerRewardV1(requestParameters: ProgramControllerRefundCustomerRewardV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerRefundCustomerRewardV1.');
        }
        const claimId = requestParameters.claimId;
        if (claimId === null || claimId === undefined) {
            throw new Error('Required parameter claimId was null or undefined when calling programControllerRefundCustomerRewardV1.');
        }
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/rewards/${encodeURIComponent(String(claimId))}/refund`,
            null,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerRegisterCustomerV1(requestParameters: ProgramControllerRegisterCustomerV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<RegisterResponseDto>;
    public programControllerRegisterCustomerV1(requestParameters: ProgramControllerRegisterCustomerV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<RegisterResponseDto>>;
    public programControllerRegisterCustomerV1(requestParameters: ProgramControllerRegisterCustomerV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<RegisterResponseDto>>;
    public programControllerRegisterCustomerV1(requestParameters: ProgramControllerRegisterCustomerV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const registerCustomer = requestParameters.registerCustomer;
        if (registerCustomer === null || registerCustomer === undefined) {
            throw new Error('Required parameter registerCustomer was null or undefined when calling programControllerRegisterCustomerV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerRegisterCustomerV1.');
        }
        const referral = requestParameters.referral;
        const utmCampaign = requestParameters.utmCampaign;
        const utmSource = requestParameters.utmSource;
        const utmMedium = requestParameters.utmMedium;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (utmCampaign !== undefined && utmCampaign !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmCampaign, 'utmCampaign');
        }
        if (utmSource !== undefined && utmSource !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmSource, 'utmSource');
        }
        if (utmMedium !== undefined && utmMedium !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>utmMedium, 'utmMedium');
        }

        let headers = this.defaultHeaders;
        if (referral !== undefined && referral !== null) {
            headers = headers.set('referral', String(referral));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<RegisterResponseDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/register`,
            registerCustomer,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerSendPassToCustomerV1(requestParameters: ProgramControllerSendPassToCustomerV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerSendPassToCustomerV1(requestParameters: ProgramControllerSendPassToCustomerV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerSendPassToCustomerV1(requestParameters: ProgramControllerSendPassToCustomerV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerSendPassToCustomerV1(requestParameters: ProgramControllerSendPassToCustomerV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const checkCustomer = requestParameters.checkCustomer;
        if (checkCustomer === null || checkCustomer === undefined) {
            throw new Error('Required parameter checkCustomer was null or undefined when calling programControllerSendPassToCustomerV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerSendPassToCustomerV1.');
        }
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/send-pass`,
            checkCustomer,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerSendValidationEmailV1(requestParameters: ProgramControllerSendValidationEmailV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerSendValidationEmailV1(requestParameters: ProgramControllerSendValidationEmailV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerSendValidationEmailV1(requestParameters: ProgramControllerSendValidationEmailV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerSendValidationEmailV1(requestParameters: ProgramControllerSendValidationEmailV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const checkCustomer = requestParameters.checkCustomer;
        if (checkCustomer === null || checkCustomer === undefined) {
            throw new Error('Required parameter checkCustomer was null or undefined when calling programControllerSendValidationEmailV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerSendValidationEmailV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/send-validation-email`,
            checkCustomer,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerStoreCustomerClickV1(requestParameters: ProgramControllerStoreCustomerClickV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public programControllerStoreCustomerClickV1(requestParameters: ProgramControllerStoreCustomerClickV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public programControllerStoreCustomerClickV1(requestParameters: ProgramControllerStoreCustomerClickV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public programControllerStoreCustomerClickV1(requestParameters: ProgramControllerStoreCustomerClickV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const createClick = requestParameters.createClick;
        if (createClick === null || createClick === undefined) {
            throw new Error('Required parameter createClick was null or undefined when calling programControllerStoreCustomerClickV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerStoreCustomerClickV1.');
        }
        const userAgent = requestParameters.userAgent;
        const xSessionId = requestParameters.xSessionId;
        const xClientIp = requestParameters.xClientIp;
        const xAPPLANGUAGE = requestParameters.xAPPLANGUAGE;

        let headers = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            headers = headers.set('user-agent', String(userAgent));
        }
        if (xSessionId !== undefined && xSessionId !== null) {
            headers = headers.set('x-session-id', String(xSessionId));
        }
        if (xClientIp !== undefined && xClientIp !== null) {
            headers = headers.set('x-client-ip', String(xClientIp));
        }
        if (xAPPLANGUAGE !== undefined && xAPPLANGUAGE !== null) {
            headers = headers.set('X-APP-LANGUAGE', String(xAPPLANGUAGE));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/clicks`,
            createClick,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerUpdateCustomerPreferencesV1(requestParameters: ProgramControllerUpdateCustomerPreferencesV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Customer>;
    public programControllerUpdateCustomerPreferencesV1(requestParameters: ProgramControllerUpdateCustomerPreferencesV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Customer>>;
    public programControllerUpdateCustomerPreferencesV1(requestParameters: ProgramControllerUpdateCustomerPreferencesV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Customer>>;
    public programControllerUpdateCustomerPreferencesV1(requestParameters: ProgramControllerUpdateCustomerPreferencesV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const updateCustomerPreferences = requestParameters.updateCustomerPreferences;
        if (updateCustomerPreferences === null || updateCustomerPreferences === undefined) {
            throw new Error('Required parameter updateCustomerPreferences was null or undefined when calling programControllerUpdateCustomerPreferencesV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerUpdateCustomerPreferencesV1.');
        }
        const customerId = requestParameters.customerId;
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling programControllerUpdateCustomerPreferencesV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<Customer>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/${encodeURIComponent(String(customerId))}/preferences`,
            updateCustomerPreferences,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerUpdateCustomerProfileV1(requestParameters: ProgramControllerUpdateCustomerProfileV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Customer>;
    public programControllerUpdateCustomerProfileV1(requestParameters: ProgramControllerUpdateCustomerProfileV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Customer>>;
    public programControllerUpdateCustomerProfileV1(requestParameters: ProgramControllerUpdateCustomerProfileV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Customer>>;
    public programControllerUpdateCustomerProfileV1(requestParameters: ProgramControllerUpdateCustomerProfileV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const updateCustomerProfile = requestParameters.updateCustomerProfile;
        if (updateCustomerProfile === null || updateCustomerProfile === undefined) {
            throw new Error('Required parameter updateCustomerProfile was null or undefined when calling programControllerUpdateCustomerProfileV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerUpdateCustomerProfileV1.');
        }
        const customerId = requestParameters.customerId;
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling programControllerUpdateCustomerProfileV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<Customer>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/${encodeURIComponent(String(customerId))}/profile`,
            updateCustomerProfile,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public programControllerValidateCustomerV1(requestParameters: ProgramControllerValidateCustomerV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Customer>;
    public programControllerValidateCustomerV1(requestParameters: ProgramControllerValidateCustomerV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Customer>>;
    public programControllerValidateCustomerV1(requestParameters: ProgramControllerValidateCustomerV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Customer>>;
    public programControllerValidateCustomerV1(requestParameters: ProgramControllerValidateCustomerV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const checkCustomer = requestParameters.checkCustomer;
        if (checkCustomer === null || checkCustomer === undefined) {
            throw new Error('Required parameter checkCustomer was null or undefined when calling programControllerValidateCustomerV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programControllerValidateCustomerV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<Customer>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/validate`,
            checkCustomer,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
